export const Field = ({ label, children }) => (
  <div className="flex flex-col gap-1.5">
    <label className="text-xs font-semibold uppercase tracking-wide text-gray-500">{label}</label>
    {children}
  </div>
);

export const inputClass =
  "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 shadow-sm outline-none focus:border-pink-500 focus:ring-2 focus:ring-pink-100";

export const TextInput = (props) => <input {...props} className={inputClass} />;
export const NumberInput = (props) => <input type="number" min={0} {...props} className={inputClass} />;
export const Select = ({ children, ...props }) => (
  <select {...props} className={inputClass}>{children}</select>
);
export const TextArea = (props) => <textarea {...props} className={inputClass} />;

export const Toggle = ({ checked, onChange, id }) => (
  <label htmlFor={id} className="relative inline-flex cursor-pointer items-center">
    <input id={id} type="checkbox" checked={checked} onChange={onChange} className="peer sr-only" />
    <div className="h-6 w-11 rounded-full bg-gray-300 transition-colors peer-checked:bg-pink-600" />
    <div className="absolute left-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform peer-checked:translate-x-5" />
  </label>
);

export const SmallButton1 = ({ children, ...props }) => (
  <button
    {...props}
    className="w-full rounded-lg bg-pink-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pink-700 disabled:opacity-50"
  />
);

export const SmallButton = ({ children, ...props }) => (
  <button
    {...props}
    className="w-full rounded-lg bg-pink-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-pink-700 disabled:opacity-50"
  >
    {children}
  </button>
);